import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Icon, Tooltip } from 'antd';
import { ZAGGLE_PROPEL_CORPORATE_GIFTING_CONFIG } from '../ClientLogin/constants';
import StyledClientLogin from '../ClientLogin/styledClientLogin';
import { constants } from '../../devUtils';
import { PropelCorporateGiftingHeaderProps } from './manipalcignaHeaderDataHandler';
import Container from '../../components/Container';

class PropelCorporateGiftingHeader extends PureComponent {
  componentDidMount() {
    const stickyBodyEle = document.querySelector('.stickyBody');
    if (stickyBodyEle) {
      stickyBodyEle.classList.add('propelCorpGiftingStickyBody');
    }
  }

  propelCorporateGiftingHeaderIcons(otherParams) {
    const {
      isLoggedIn,
      handleShowLogin,
      handleLogout,
      cart = {},
    } = otherParams;
    if (isLoggedIn) {
      return (
        <Fragment>
          <Link to={constants.GIFT_CARD_CART} className="cart" >
            <Tooltip placement="top" title="My Cart">
              <Icon type="shopping-cart" className="icon-raise" />
              {(cart && cart.items_count && cart.items_count !== 0) ?
                <span className="badge">{cart.items_count}</span> : null}
            </Tooltip>
          </Link>
          <Link to={constants.LINK_MY_PROFILE} >
            <Tooltip placement="top" title="My Account">
              <Icon type="user" className="icon-raise" />
            </Tooltip>
          </Link>
          <Tooltip placement="top" title="Logout">
            <Icon type="logout" className="icon-raise" onClick={() => handleLogout()} />
          </Tooltip>
        </Fragment>
      );
    }
    return (
      <Tooltip placement="top" title="Login">
        <Icon type="logout" className="icon-raise" onClick={() => handleShowLogin()} />
      </Tooltip>
    );
  }

  propelCorporateGiftingHeader(otherParams) {
    const {
      logo,
      brand_logo,
    } = otherParams;
    return (
      <section className="cilent-fixed-nav">
        <div className="client-secoundary-header-bg">
          <Container>
            <Row align="middle" type="flex" className="client-header">
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="portal_name">
                  <a href={constants.LINK_PROPEL_CORPORATE_GIFITING_HOME} >
                    <img src={brand_logo} alt="no_image" className="prop-corp-gift xmas-spec-logo" />
                  </a>
                </div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} className="text-right">
                <div className="portal_name">
                  <a href={constants.LINK_PROPEL_OVERVIEW} target="_blank">
                    <img src={logo} alt="no_image" className="prop-corp-gift" />
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <Row align="middle" type="flex" className="client-header-bg">
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-right">
            <Container>
              <Link to={constants.LINK_PROPEL_CORPORATE_GIFITING} >
                <Tooltip placement="top" title="Home">
                  <Icon type="home" className="icon-raise" />
                </Tooltip>
              </Link>
              { this.propelCorporateGiftingHeaderIcons(otherParams)}
            </Container>
          </Col>
        </Row>
      </section>
    );
  }

  render() {
    const {
      isOnlyMerchandise = false,
      cart,
      loggedIn,
      handleLogout,
      history: {
        location: {
          pathname = '',
        } = {},
      } = {},
      handleShowLogin,
    } = this.props;
    const {
      slider_images,
      logo,
      about_title,
      about_description,
      secondary_title,
      portal_name,
      redirect_loginSuccess,
      top_banner,
      welcome_title,
      welcome_description,
      brand_logo,
      ...otherProps
    } = ZAGGLE_PROPEL_CORPORATE_GIFTING_CONFIG;
    return (
      <StyledClientLogin {...otherProps}>
        <header>
          {this.propelCorporateGiftingHeader({
            brand_logo,
            logo,
            portal_name,
            top_banner,
            isLoggedIn: loggedIn,
            isOnlyMerchandise,
            handleShowLogin,
            handleLogout,
            pathname,
            cart,
          })}
        </header>
      </StyledClientLogin>
    );
  }
}

PropelCorporateGiftingHeader.propTypes = PropelCorporateGiftingHeaderProps;
export default PropelCorporateGiftingHeader;



// WEBPACK FOOTER //
// client/containers/HeaderContainer/propelCorporateGiftingHeader.js